import React from 'react';
import { useTranslation } from 'react-i18next';
import formattingUtils from '../../../Utils/formattingUtils';
import PackageStructureProductRow from './PackageStructureProductRowBeta';
import { VossProductGroupType, VossProductGroupTypeText } from '../../../Constants/VOSS/vossProductGroupType';

const PackageStructureGroupRow = ({ group }) => {
    const { t } = useTranslation();

    // Calculate total price for the group
    const totalPrice = group.products.reduce((sum, product) => sum + product.price, 0);

    return (
        <div className="simulation-group-container">
            <div className="simulation-group-header">
                <div className="group-header-left">
                    <span className="vismaicon vismaicon-sm vismaicon-open"></span>
                    <span className="group-name">{group.name}</span>
                    <span className={`tag-badge tag-${group.productGroupType === VossProductGroupType.Included ? 'included' : 'optional'}`}>
                        {t(VossProductGroupTypeText[group.productGroupType] || 'vossProductGroupType.included')}
                    </span>
                </div>
                <span className="price-value bold">{formattingUtils.currencyFormatter(totalPrice)}</span>
            </div>
            <div className="simulation-products-list">
                {group.products.map((product) => (
                    <PackageStructureProductRow key={product.id} product={product} />
                ))}
            </div>
        </div>
    );
};

export default PackageStructureGroupRow;
